export * from "./input-editor.component";
